// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__BpzJM","tooltip":"Tooltip_tooltip__tIirw","smooth-appear":"Tooltip_smooth-appear__uLyC7"};